import { BasicInfo, MainCta } from '@/vdp/VehicleInfo';
import { withErrorBoundary } from '~/utilities/ErrorBoundary';

function FallbackVehicleInfoCard() {
  return (
    <div className="flex w-full flex-col gap-2xl bg-white px-2xl py-2xl sm:rounded-xl sm:shadow-[0px_28px_56px_0px_rgba(36,_41,_46,_0.04),_0px_8px_16px_0px_rgba(36,_41,_46,_0.12)] lg:p-4xl">
      <BasicInfo />
      <MainCta />
    </div>
  );
}

export default withErrorBoundary(FallbackVehicleInfoCard);
